<template>
    <div>
        <v-file-input
                v-model="textfield"
                :label="label"
                :readonly="readonly"
                outlined
                :prepend-icon="''"
                :prepend-inner-icon="'mdi-paperclip'"
                :type="type"
                :min="min"
                :max="max"
                :color="color ? color : inputColor"
                :background-color="color ? `${color} lighten-5` : backgroundColor"
                :clearable="!readonly"
                @click:clear="clear"
                dense
                :disabled="disabled"
                :hint="hint"
                :persistent-hint="persistentHint"
                :placeholder="placeholder"
                :autofocus="autoFocus"
                :step="step"
                :suffix="suffix"
                :prefix="prefix"
                hide-details="auto"
                :rules="rules"
                @focus="$emit('focus')"
                @blur="$emit('blur')"
        ></v-file-input>

        <input type="hidden"/>
    </div>
</template>


<script>
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    name: 'WFileInput',
    props: {
        value: [Object, File],
        label: String,
        color: String,
        disabled: Boolean,
        autoFocus: Boolean,
        readonly: Boolean,
        rules: Array,
        type: String,
        min: String,
        max: String,
        hint: String,
        persistentHint: Boolean,
        placeholder: String,
        step: String,
        suffix: String,
        prefix: String,
    },
    setup(props, { emit }) {
        const {inputColor, backgroundColor} = useSharedData();

        const textfield = ref(null);

        function save() {
            emit("input", textfield.value);
        }

        function clear() {
            textfield.value = null;
            emit("input", null);
        }

        watch(() => props.value, () => {
            if(props.value)
                textfield.value = props.value;
        });

        watch(() => textfield.value, () => {
            emit("input", textfield.value)
        });

        return {
            inputColor,
            backgroundColor,
            textfield,
            save,
            clear,
        }
    },
};
</script>